import { useState } from 'react';
import { Card, Typography, Input, Button, Space, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useApi } from '../../hooks/use_api';

const { Title } = Typography;

/** Self-service password change, proxied through the backend to Keycloak's
 * Account REST API (which verifies currentPassword itself). */
function ChangePassword() {
    const api = useApi();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [busy, setBusy] = useState(false);

    const mismatch = newPassword && confirmPassword && newPassword !== confirmPassword;
    const canSubmit = currentPassword && newPassword.length >= 8 && newPassword === confirmPassword;

    const handleSubmit = () => {
        if (!canSubmit) return;
        setBusy(true);
        api.post('/api/account/security/password', { current_password: currentPassword, new_password: newPassword })
            .then(() => {
                message.success('Password updated');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            })
            .catch(err => message.error(err.message || 'Could not update password'))
            .finally(() => setBusy(false));
    };

    return (
        <Card style={{ marginTop: 16 }}>
            <Title level={5} style={{ marginTop: 0 }}>Password</Title>
            <Space direction="vertical" style={{ width: '100%', maxWidth: 360 }} size={8}>
                <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Current password"
                    value={currentPassword}
                    onChange={e => setCurrentPassword(e.target.value)}
                    disabled={busy}
                />
                <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="New password"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    disabled={busy}
                />
                <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    onPressEnter={handleSubmit}
                    disabled={busy}
                    status={mismatch ? 'error' : ''}
                />
                <Button type="primary" onClick={handleSubmit} loading={busy} disabled={!canSubmit}>
                    Update password
                </Button>
            </Space>
        </Card>
    );
}

export default ChangePassword;
